import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoaderService } from './loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit, OnDestroy {

  loading: boolean;

  private subscriptions = new Subscription();

  constructor(
    private loaderService: LoaderService,
  ) {
  }

  ngOnInit() {
    this.subscriptions.add(this.loaderService.loading$.subscribe(loading => this.loading = loading));
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

}
